<template>
  <div class="management-flags-comparison">
    <a-card
        :bordered="true"
        class="management-flags-comparison__card pdf-avoid-break"
    >
      <a-tag class="management-flags-comparison__tag management-flags-comparison__tag--previous">
        {{ previousLabel }}
      </a-tag>

      <div class="management-flags-comparison__header">
        <h3 class="management-flags-comparison__card-title">
          Зеленые и красные флаги
        </h3>

        <QuestionCircleOutlined class="management-flags-comparison__help-icon" />
      </div>

      <FlagsDetailedCard
          :groups="previousGroups"
          :segments="previousSegments"
          :smallGap="false"
      />
    </a-card>

    <a-card
        :bordered="true"
        class="management-flags-comparison__card pdf-avoid-break"
    >
      <a-tag class="management-flags-comparison__tag management-flags-comparison__tag--current">
        {{ currentLabel }}
      </a-tag>

      <div class="management-flags-comparison__header">
        <h3 class="management-flags-comparison__card-title">
          Зеленые и красные флаги
        </h3>

        <QuestionCircleOutlined class="management-flags-comparison__help-icon" />
      </div>

      <FlagsDetailedCard
          :groups="currentGroups"
          :segments="currentSegments"
          :smallGap="false"
      />
    </a-card>
  </div>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

import FlagsDetailedCard from '@/components/Analytics/FlagsDetailedCard.vue'

export default {
  name: 'ManagementFlagsComparisonBlock',

  components: {
    QuestionCircleOutlined,
    FlagsDetailedCard,
  },

  props: {
    previousLabel: {
      type: String,
      default: 'Было',
    },

    currentLabel: {
      type: String,
      default: 'Стало',
    },

    previousGroups: {
      type: Array,
      default: () => [],
    },

    previousSegments: {
      type: Array,
      default: () => [],
    },

    currentGroups: {
      type: Array,
      default: () => [],
    },

    currentSegments: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.management-flags-comparison {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.management-flags-comparison__card {
  position: relative;
  min-width: 0;
  border-radius: 8px;
}

.management-flags-comparison__card :deep(.ant-card-body) {
  padding: 18px 16px 14px;
}

.management-flags-comparison__tag {
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 2;
  margin: 0;
  height: 20px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
  background: #ffffff;
}

.management-flags-comparison__tag--previous {
  color: rgba(0, 0, 0, 0.65);
  border-color: #d5dbe2;
}

.management-flags-comparison__tag--current {
  color: var(--geek-blue);
  border-color: var(--geek-blue-3);
  background-color: var(--geek-blue-1);
}

.management-flags-comparison__header {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.management-flags-comparison__card-title {
  min-width: 0;
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.management-flags-comparison__help-icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
}

.management-flags-comparison :deep(.flags-detailed-card__groups) {
  gap: 20px;
}

.management-flags-comparison :deep(.flags-detailed-card__group-header) {
  margin-bottom: 12px;
}

.management-flags-comparison :deep(.flags-detailed-card__bar) {
  margin-top: 14px;
}

@media (max-width: $tablet-breakpoint) {
  .management-flags-comparison {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .management-flags-comparison__card :deep(.ant-card-body) {
    padding: 18px 12px 14px;
  }

  .management-flags-comparison :deep(.flags-detailed-card__row) {
    grid-template-columns: minmax(0, 1fr) minmax(24px, 34px) minmax(44px, 54px);
    gap: 8px;
    padding-left: 18px;
  }
}
</style>